import { setSpecificMessage, email } from "valibot";
setSpecificMessage(
  email,
  (issue) => `Email invalide: reçu ${issue.received}`,
  "fr"
);